import React from 'react'

export const howItWorks = [
	{
		icon: 'building',
		text: (
			<>
				<strong>יזמי נזל"ן</strong>
				{' '}
				מגישים תוכנית חדשה לוועדת התכנון
				באמצעות מערכת "תכנון זמין"
			</>
		),
	},
	{
		icon: 'paper-plane',
		text: (
			<>
				<strong>מעירים</strong>
				{' '}
				מזהה שהוגשה תוכנית חדשה ושולחת לכל
				הנרשמים באיזור הרלוונטי התראה בדואר אלקטרוני
			</>
		),
	},
	{
		icon: 'chart-area',
		text: (
			<>
				<strong>אתם</strong>
				{' '}
				מקבלים התראה רלוונטית עם לינק לתוכנית המלאה
				ומידע מונגש שעוזר להבין את מהות התוכנית
			</>
		),
	},
];

export const whatSay = [
	{
		text: 'מעירים זו מהפכה והיא חשובה לתקשורת עם האזרח, אקדם את הטמעת המערכת בקריית אונו',
		name: 'עו"ד נירית בלייר',
		title: 'חברת מועצת העיר קריית אונו',
	},

	{
		text: 'מעירים נותן לנו כלים יעילים להתמודד עם תהליכי תכנון שלעתים רבות סמויים מן העין אבל משפיעים ישירות על החיים שלנו',
		name: 'ערן בן ימיני',
		title: 'מנכ"ל ארגון חיים וסביבה',
	},

	{
		text: 'קיבלתי מידע חשוב על תכנית פיתוח משמעותית הצמודה לביתי. זה איפשר לי להיערך עם השכנים, להגיש התנגדות ואף להביא לשיפור המצב התכנוני שאושר בעבורנו.',
		name: 'יהונתן הימן',
		title: 'מתכנן קהילתי, ירושלים',
	},
	{
		text: 'מעירים הוא כלי עבודה נהדר, בייחוד במעכב אחרי תכניות בסמכות מקומית',
		name: 'מנהל התכנון',
		title: '',
	},
	{
		text: 'מעירים הוא כלי שמחזיר לי מעט כוח במערכת היחסים המורכבת והלא מאוזנת מול הרשות העירונית ונבכי הבירוקרטיה שלה.',
		name: 'יואב שפרנק',
		title: 'פעיל חברתי, דרום תל אביב',
	},
];
